import { pickIntent } from "./helpers/ui.js";
import './assets/constants2.css';const root = "_root_1b0ov_1";
const withTheme = "_withTheme_1b0ov_40";
const iconWrapper = "_iconWrapper_1b0ov_54";
const regular = "_regular_1b0ov_59";
const primary = "_primary_1b0ov_65";
const secondary = "_secondary_1b0ov_79";
const critical = "_critical_1b0ov_93";
const warning = "_warning_1b0ov_93";
const disabled = "_disabled_1b0ov_143";
const inline = "_inline_1b0ov_151";
const contentContainer = "_contentContainer_1b0ov_242";
const content = "_content_1b0ov_242";
const fill = "_fill_1b0ov_268";
const uppercase = "_uppercase_1b0ov_275";
const s = {
  root,
  withTheme,
  iconWrapper,
  regular,
  primary,
  secondary,
  critical,
  warning,
  disabled,
  inline,
  contentContainer,
  content,
  fill,
  uppercase
};
const BUTTON_INTENT = pickIntent(["primary", "secondary", "critical", "warning"]);
const BUTTON_INTENT_CLASSNAME_MAP = {
  [BUTTON_INTENT.PRIMARY]: s.primary,
  [BUTTON_INTENT.SECONDARY]: s.secondary,
  [BUTTON_INTENT.CRITICAL]: s.critical,
  [BUTTON_INTENT.WARNING]: s.warning
};
export {
  BUTTON_INTENT as B,
  BUTTON_INTENT_CLASSNAME_MAP as a,
  s
};
